import React from 'react';

interface SpecificServiceSelectionProps {
    onBack: () => void;
}

export const SpecificServiceSelection: React.FC<SpecificServiceSelectionProps> = ({
    onBack,
}) => {
    const handleFinishServiceStep = () => {
        console.log('Finish service selection');
    };

    return (
        <div>
            <h2>Select Specific Services</h2>
            <button onClick={onBack}>[Back]</button>
            <button onClick={handleFinishServiceStep}>[Continue]</button>
        </div>
    );
};
